import { Divider, Grid, Typography } from "@mui/material";
import { TabHeader } from "./TabHeader";
import OptionButton from "../buttons/OptionButton";
import { getUid, signOut } from "../../auth/user";
import { DialogContext } from "../../provider/DialogProvider";
import React from "react";
import { SnackbarContext } from "../../provider/SnackbarProvider";
import { GameContext } from "../../provider/GameProvider";
import { Game } from "../../types/game";
import { saveGameInCloud } from "../../save/database";
import { saveObjectToLocalStorage } from "../../save/localSave";
export default function OptionsTab() {
  const uid = getUid();
  const {
    setCheatDialogOpen,
    setSignInSignUpDialogOpen,
    setSignDialogType,
    setDeleteDialogOpen,
  } = React.useContext(DialogContext);
  const { showSnackbar } = React.useContext(SnackbarContext);
  const { game, autoSave, setAutoSave } = React.useContext(GameContext);

  return (
    <div>
      <Grid container spacing={2} style={{ paddingBottom: 180 }}>
        <TabHeader />
        <Grid item md={12} xs={12} style={{ paddingBottom: 24 }}>
          <Typography
            variant="h5"
            style={{ textAlign: "center", color: "lightblue" }}
          >
            Options
          </Typography>
        </Grid>
        <Grid item md={4} xs={4}>
          <OptionButton
            title="Reset"
            onClick={() => {
              setDeleteDialogOpen(true);
            }}
          />
        </Grid>
        <Grid item md={4} xs={4}>
          <OptionButton
            title={autoSave ? "Auto Save: On" : "Auto Save: Off"}
            onClick={() => {
              saveObjectToLocalStorage("autoSave", !autoSave);
              setAutoSave(!autoSave);
            }}
          />
        </Grid>
        <Grid item md={4} xs={4}>
          <OptionButton
            title="Cheats"
            onClick={() => {
              setCheatDialogOpen(true);
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ paddingTop: 32 }}>
        <Grid item md={12} xs={12} style={{ paddingBottom: 24 }}>
          <Divider style={{ width: "100%" }} />
        </Grid>
        <Grid item xs={12}>
          <div>
            <Typography
              variant="h5"
              style={{
                textAlign: "center",
                paddingBottom: 24,
                color: "lightblue",
              }}
            >
              You are {uid ? "logged in" : "not logged in"}
            </Typography>

            {!uid && (
              <Typography style={{ textAlign: "center", color: "lightblue" }}>
                You need to be logged in to cloud save
              </Typography>
            )}
          </div>
        </Grid>
        <Grid item xs={4}>
          <OptionButton
            title={uid ? "Logout" : "Login"}
            onClick={() => {
              if (!uid) {
                setSignDialogType("login");
                setSignInSignUpDialogOpen(true);
              } else {
                signOut();
                showSnackbar("Logged out");
              }
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <OptionButton
            title="Sign Up"
            onClick={() => {
              if (!uid) {
                setSignDialogType("signup");
                setSignInSignUpDialogOpen(true);
              } else {
                showSnackbar("You are already logged in");
              }
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <OptionButton
            title="Cloud Save"
            onClick={() => {
              if (uid) {
                saveGameInCloud(uid, { ...game, timestamp: Date.now() });
                showSnackbar("Game saved in cloud");
              } else {
                showSnackbar("You need to be logged in to save in the cloud");
              }
            }}
          />
        </Grid>
      </Grid>
      <Typography
        style={{
          position: "absolute",
          bottom: 32,
          left: "50%",
          transform: "translateX(-50%)",
        }}
        variant="body2"
      ></Typography>
    </div>
  );
}
